import { Icon, IconButton, InputAdornment, TextField, TextFieldProps } from '@mui/material';
import React, { KeyboardEvent, useState } from 'react';

interface SearchTextProps {
    onSearch?: (value: string) => void;
}

export const SearchTextField: React.FunctionComponent<SearchTextProps & TextFieldProps> = (props) => {
    const { onSearch, ...rest } = props;

    const [value, setValue] = useState('');

    const checkEnter = (evt: KeyboardEvent) => {
        if ('Enter' === evt.key && onSearch) {
            onSearch(value);
        }
    };

    return (
        <TextField
            fullWidth
            name='search'
            label='Search'
            variant='outlined'
            {...rest}
            onKeyDown={checkEnter}
            value={value}
            onChange={(evt) => setValue(evt.target.value)}
            InputProps={{
                endAdornment: (
                    <InputAdornment position='end'>
                        <IconButton aria-label='search' edge='end' onClick={() => onSearch && onSearch(value)}>
                            <Icon>search</Icon>
                        </IconButton>
                    </InputAdornment>
                ),
            }}
        />
    );
};
